/*
 * @Author: xiaodong 565071984@qq.com
 * @Date: 2022_06_10 16:00:06
 * @LastEditors: elf9237 565071984@qq.com
 * @LastEditTime: 2024-12-12 14:42:24
 * @FilePath: /@src/assets/color/colors_light.js
 * @Description:睿易和星耀两者颜色数量不一致，先在基础上做缺失补充，已有的用元色值库颜色
 * 颜色新增要慎重，要不然越来越乱
 */

/**
 *            告同胞书
 *
 *     colors_cloud_dark_all 里面的色值变量，大家不要使用，若设计存在直接使用，请联系设计师优化或发起新增场景变量
 *     colors_cloud_dark_tmp 优先使用这里的变量，否则暗黑会出问题，请大家遵守
 *
 *
 */
import { getOpColor } from './colorUtils.js';
const colors_dark_all = {
  //品牌紫赛博紫mauve26-3-5修订
  mauve_1: '#25223A',
  mauve_2: '#1A172D',
  mauve_3: '#362D6B',
  mauve_4: '#4A3C95',
  mauve_5: '#957AF7', //26-3-5修订
  mauve_6: '#8B5DF5', //26-3-5修订
  mauve_7: '#5C49BF',
  mauve_8: '#957AF7', //26-3-5修订
  mauve_9: '#7E5DF5',
  mauve_10: '#6249BF',

  //品牌蓝赛博蓝blue26-3-5新修改
  blue_1: '#162A3A', //26-3-5修订
  blue_2: '#0C1E2B', //26-3-5修订
  blue_3: '#0D426B', //26-3-5修订
  blue_4: '#09548E', //26-3-5修订
  blue_5: '#3DA5F4', //26-3-5修订
  blue_6: '#0F90F2', //26-3-5修订
  blue_7: '#0B6DB8', //26-3-5修订
  blue_8: '#3DA5F4', //26-3-5修订
  blue_9: '#0F90F2', //26-3-5修订
  blue_10: '#0B84B8', //26-3-5修订

  //睿易绿kygreen
  kygreen_1: '#162F25',
  kygreen_2: '#0C2219',
  kygreen_3: '#0C5335',
  kygreen_4: '#166E49',
  kygreen_5: '#38C78C',
  kygreen_6: '#0BBD73',
  kygreen_7: '#15965E',
  kygreen_8: '#34C78A',
  kygreen_9: '#0BBD73',
  kygreen_10: '#0E8F59',

  //睿易蓝kyblue
  kyblue_1: '#1A263B',
  kyblue_2: '#0F192B',
  kyblue_3: '#17376D',
  kyblue_4: '#184B94',
  kyblue_5: '#4991F5',
  kyblue_6: '#237EFC',
  kyblue_7: '#1B62C4',
  kyblue_8: '#4C93F7',
  kyblue_9: '#227AF5',
  kyblue_10: '#1856C2',
  kyblue_11: '#EAF2FF', //只能暗黑用，大家不可直接引用哈

  //中性色neutral colors
  gray_1: '#000000',
  gray_2: '#0C0D0F',
  gray_3: '#18191C',
  gray_4: '#1E2024',
  gray_5: '#25272B',
  gray_6: '#2D2F33',
  gray_7: '#37393D',
  gray_8: '#4D4E52',
  gray_9: '#73757A',
  gray_10: '#A5A7AC',
  gray_11: '#C4C6CC', //26-3-4修改
  gray_12: '#E6E7EB', //26-3-4修改
  gray_13: '#FFFFFF',

  //日暮橙Orange
  orange_1: '#372B1F',
  orange_2: '#291E13',
  orange_3: '#6B431C',
  orange_4: '#975A1D',
  orange_5: '#FBA44F',
  orange_6: '#FA932D',
  orange_7: '#C77210',
  orange_8: '#FBA44F',
  orange_9: '#FA932D',
  orange_10: '#C77210',

  // 紫罗兰purple
  purple_1: '#2D2038',
  purple_2: '#201529',
  purple_3: '#4F2765',
  purple_4: '#6D328A',
  purple_5: '#C169EE',
  purple_6: '#B14DE3',
  purple_7: '#8D3BB7',
  purple_8: '#C169EE',
  purple_9: '#B14DE3',
  purple_10: '#8D3BB7',

  //柠檬绿lime
  lime_1: '#283120',
  lime_2: '#1C2414',
  lime_3: '#405821',
  lime_4: '#527523',
  lime_5: '#A0D15C',
  lime_6: '#8EC93C',
  lime_7: '#789E34',
  lime_8: '#A2D35F',
  lime_9: '#8EC93C',
  lime_10: '#789E34',

  // 金盏花yellow
  yellow_1: '#352F1D',
  yellow_2: '#272212',
  yellow_3: '#665118',
  yellow_4: '#917017',
  yellow_5: '#F0BF3A',
  yellow_6: '#EBB217',
  yellow_7: '#B28A1D',
  yellow_8: '#F0BF3A',
  yellow_9: '#EBB626',
  yellow_10: '#B28A1D',

  //薄暮红Red
  red_1: '#351E1E',
  red_2: '#281515',
  red_3: '#6A2929',
  red_4: '#9B3636',
  red_5: '#FB716F',
  red_6: '#F75454',
  red_7: '#C34242',
  red_8: '#FB716F',
  red_9: '#F75454',
  red_10: '#C34242',

  //以下色系尽量少用
  //法式洋红 Magenta
  magenta_1: '#361F2F',
  magenta_2: '#281421',
  magenta_3: '#69254C',
  magenta_4: '#8F2B62',
  magenta_5: '#F060AE',
  magenta_6: '#EB429E',
  magenta_7: '#B7337B',
  magenta_8: '#F060AE',
  magenta_9: '#EB46A0',
  magenta_10: '#B7337B',

  //锐捷红 rjred//26-3-4修改
  brandred_1: '#371521',
  brandred_2: '#260B14',
  brandred_3: '#630820',
  brandred_4: '#8C0929',
  brandred_5: '#E53C66',
  brandred_6: '#E60E43',
  brandred_7: '#B30B34',
  brandred_8: '#E53C66',
  brandred_9: '#E60E43',
  brandred_10: '#B30B34',

  //家居棕 brown
  brown_1: '#322721',
  brown_2: '#241B15',
  brown_3: '#5D3C22',
  brown_4: '#834F26',
  brown_5: '#DD965E',
  brown_6: '#D6823F',
  brown_7: '#A76531',
  brown_8: '#DD965E',
  brown_9: '#D6823F',
  brown_10: '#A76531'
};

const colors_dark_tmp = {
  //9.0 新色系

  //主题色赛博紫专业紫
  theme_light_bg: getOpColor(colors_dark_all.kyblue_6, 0.06), ////大面积浅色背景
  theme_light: getOpColor(colors_dark_all.kyblue_6, 0.12), ////主题色最浅色标签底色
  theme_light2: getOpColor(colors_dark_all.kyblue_6, 0.14), //用于灰色背景上/一级背景hover状态色
  theme_focus: getOpColor(colors_dark_all.kyblue_6, 0.4), //主题色聚焦边框
  theme_hover: colors_dark_all.kyblue_5, //主题色hover
  theme_color: colors_dark_all.kyblue_6, //主题色、链接色
  theme_active: colors_dark_all.kyblue_7, //主题色点击

  //信息色易用蓝//26-3-19修订
  info_light_bg: getOpColor(colors_dark_all.blue_6, 0.06), //信息色最浅，标签底色
  info_light: getOpColor(colors_dark_all.blue_6, 0.12), //信息色最浅，标签底色
  info_focus: getOpColor(colors_dark_all.blue_6, 0.4), //信息色聚焦、边框
  info_hover: colors_dark_all.blue_5, //信息色鼠标悬停
  info_color: colors_dark_all.blue_6, //信息色
  info_active: colors_dark_all.blue_7, //信息色active

  //成功色
  success_light_bg: getOpColor(colors_dark_all.kygreen_6, 0.06), //成功色最浅，标签底色
  success_light: getOpColor(colors_dark_all.kygreen_6, 0.12), //成功色最浅、标签背景
  success_focus: getOpColor(colors_dark_all.kygreen_6, 0.4), //成功色聚焦、边框
  success_hover: colors_dark_all.kygreen_5, //成功色hover
  success_color: colors_dark_all.kygreen_6, //成功色、信号好26-3-6修订
  success_active: colors_dark_all.kygreen_7, //成功点击

  //警告色
  warning_light_bg: getOpColor(colors_dark_all.orange_6, 0.06), //告警色最浅，标签底色
  warning_light: getOpColor(colors_dark_all.orange_6, 0.12), //告警色最浅，标签底色
  warning_focus: getOpColor(colors_dark_all.orange_6, 0.4), //告警色聚焦、边框
  warning_hover: colors_dark_all.orange_5, //告警色鼠标悬停
  warning_color: colors_dark_all.orange_6, //告警色、信号差26-3-6修订
  warning_active: colors_dark_all.orange_7, //告警色点击

  //错误色-
  error_light_bg: getOpColor(colors_dark_all.red_6, 0.06), //错误色最浅
  error_light: getOpColor(colors_dark_all.red_6, 0.12), //错误色最浅，标签底色
  error_focus: getOpColor(colors_dark_all.red_6, 0.4), //错误色聚焦、边框
  error_hover: colors_dark_all.red_5, //错误色鼠标悬停
  error_color: colors_dark_all.red_6, //错误色
  error_active: colors_dark_all.red_7, //错误色active

  // 信号一般-中等26-3-6修订
  average_light_bg: getOpColor(colors_dark_all.yellow_6, 0.06), //常用于信号一般/vip氛围场景
  average_light: getOpColor(colors_dark_all.yellow_6, 0.12), //常用于信号一般/vip氛围场景
  average_light2: getOpColor(colors_dark_all.yellow_6, 0.15), //常用于信号一般/vip氛围场景
  average_focus: getOpColor(colors_dark_all.yellow_6, 0.4), //常用于信号一般/vip氛围场景
  average_hover: colors_dark_all.yellow_5, //常用于信号一般/vip氛围场景
  average_color: colors_dark_all.yellow_6, //常用于信号一般/vip氛围场景
  average_active: colors_dark_all.yellow_7, //常用于信号一般/vip氛围场景

  //文字色26-3-11修订
  text_title: colors_dark_all.gray_12, //标题文字色
  text_primary: colors_dark_all.gray_11, //主要文字颜色
  text_secondary: colors_dark_all.gray_9, //次要文字颜色
  text_secondary2: colors_dark_all.gray_10, //次要文字颜色
  text_placeholder: colors_dark_all.gray_8, //说明占位字符颜色、不可用
  text_white_title: colors_dark_all.gray_13, //白色，标题&按钮
  text_white_secondary2: getOpColor(colors_dark_all.gray_13, 0.65), //白色,正文或次要文字
  text_white_secondary: getOpColor(colors_dark_all.gray_13, 0.45), //白色，辅助文案
  text_white_placeholder: getOpColor(colors_dark_all.gray_13, 0.3), //白色对应禁用态
  text_black: colors_dark_all.gray_3, //黑色

  //线条色
  border_base8: getOpColor(colors_dark_all.kyblue_11, 0.08), //分割线，8%透明度
  border_darker16: getOpColor(colors_dark_all.kyblue_11, 0.16), //边框，12%透明度
  border_darkerBtn: getOpColor(colors_dark_all.kyblue_11, 0.24), //边框，24%透明度
  border_White12: getOpColor(colors_dark_all.gray_13, 0.12), //白色分割，12%透明度
  border_White24: getOpColor(colors_dark_all.gray_13, 0.24), //白色边框，24%透明度

  //图标色//26-3-6修订
  icon_base: colors_dark_all.mauve_6, //26-3-4新修改
  icon_fill: getOpColor(colors_dark_all.mauve_6, 0.8), //26-3-4新修改
  icon_hover: colors_dark_all.mauve_5, //26-3-4新修改

  //背景色
  bg_page: colors_dark_all.gray_2, //页面背景
  bg_popup: colors_dark_all.gray_4, //灰底抽屉弹窗
  bg_dialog: colors_dark_all.gray_4, //白底弹窗,对话框
  bg_popover: colors_dark_all.gray_5, //气泡_浮层
  bg_toast: colors_dark_all.gray_8, ////toast
  bg_toast_white: colors_dark_all.gray_8, //toast白色
  bg_mask: getOpColor(colors_dark_all.gray_1, 0.5), //蒙层
  bgg_MaskPreview: getOpColor(colors_dark_all.gray_1, 0.95), //图片预览背景
  bg_page_White: colors_dark_all.gray_2, //白色抽屉弹窗，存量备份
  bg_MaskLight: getOpColor(colors_dark_all.gray_1, 0.25), //蒙层-更浅
  // 填充色
  fill1: getOpColor(colors_dark_all.kyblue_11, 0.05), //1级填充，深色透明
  fill1_onPage: colors_dark_all.gray_3, //1级填充，深色不透明
  onFill_opacity4: getOpColor(colors_dark_all.kyblue_11, 0.05), //2级填充_叠加层_hover
  onFill_Solid: colors_dark_all.gray_4, //2级填充，浅灰，不透明
  fill_3_opacity7: getOpColor(colors_dark_all.kyblue_11, 0.08), //3级填充
  fill_4_opacity10: getOpColor(colors_dark_all.kyblue_11, 0.11), //4级填充
  fill_5_opacity13: getOpColor(colors_dark_all.kyblue_11, 0.14), //5级填充
  fill_picker: getOpColor(colors_dark_all.kyblue_11, 0.16), //分段选择器，选中态
  fill_banner: colors_dark_all.mauve_6, //26-3-4新修改，设计写的代码

  //特殊透明背景-填充色26-3-6修订
  white_30: getOpColor(colors_dark_all.kyblue_11, 0.02), //白-用于浅色背景-半透明卡片填充色
  white_50: getOpColor(colors_dark_all.kyblue_11, 0.02), //白-用于浅色背景-半透明容器头部渐变色
  white_65: getOpColor(colors_dark_all.gray_3, 0.65), //开发查询是否有使用到？未使用到请删除。26-3-11修订
  white_80: getOpColor(colors_dark_all.gray_3, 0.8), //白-常用于深色背景-半透明容器头部渐变色
  gray_50: getOpColor(colors_dark_all.gray_2, 0.5), //用于半透明页面背景
  gray_80: getOpColor(colors_dark_all.gray_2, 0.8), //用于半透明页面背景
  //特殊透明背景-大背景26-3-6修订
  lime_light_bg: getOpColor(colors_dark_all.lime_6, 0.06), //用于大面积浅色背景
  blue_light_bg: getOpColor(colors_dark_all.blue_6, 0.06), //用于大面积浅色背景
  mauve_light_bg: getOpColor(colors_dark_all.mauve_6, 0.07), //用于大面积浅色背景
  purple_light_bg: getOpColor(colors_dark_all.purple_6, 0.07), //用于大面积浅色背景
  magenta_light_bg: getOpColor(colors_dark_all.magenta_6, 0.06), //用于大面积浅色背景

  //特殊26-3-11修订
  brand_green: '#08D19f', //开发查询是否有使用到？未使用到请删除。26-3-11修订
  brand_red: colors_dark_all.brandred_6, //锐捷红、锐捷logo使用
  text_vip: colors_dark_all.orange_8, //会员金色、日暮橙色、文字VIP色
  fill_vip: '#EDD392', //会员金色、勋章金色、VIP色填充色背景色//26-3-19修订

  //阴影26-3-6修订
  shadow_1: getOpColor(colors_dark_all.gray_1, 0.3), //阴影-基础
  shadow_freeze: colors_dark_all.gray_1, //表格冻结阴影

  //10色图表26-3-6修订
  chart_color_01: colors_dark_all.kyblue_5, //睿易蓝色
  chart_color_02: colors_dark_all.kygreen_6, //睿易绿色
  chart_color_03: colors_dark_all.orange_5, //日暮橙色
  chart_color_O4: colors_dark_all.red_4, //薄暮红色
  chart_color_05: colors_dark_all.mauve_5, //品牌紫色
  chart_color_06: colors_dark_all.orange_6, //日暮橙色
  chart_color_07: colors_dark_all.kygreen_7, //睿易绿色
  chart_color_08: colors_dark_all.magenta_4, //法式洋红色
  chart_color_09: colors_dark_all.gray_5, //中性色
  chart_color_10: colors_dark_all.blue_4, //品牌蓝色

  //其他
  tool_text_color: colors_dark_all.gray_1, //白色，标题&按钮
  tooll_text_secondary_color: colors_dark_all.gray_2 //工具页banner辅助文字
};
export const colors_dark = {
  ...colors_dark_tmp,
  ...colors_dark_all
};
// module.exports = { colors_dark };
